/**
 * «پرونده‌ی سلامت» در پروفایل خود بیمار: حالا فقط راهی به صفحه‌ی مستقل پرونده (/health-record).
 * بدون قابلیت روشن، هیچ چیزی نمی‌سازد.
 */

import { Link } from "../../router";
import { useHealthRecord } from "./useHealthRecord";
import { HR } from "./hrUi";
import ChevronIcon from "@/common/components/icons/chevron";
export default function HealthRecordProfileSection() {
  const { enabled } = useHealthRecord();
  if (!enabled) return null;
  return (
    <section className={HR.profile} id="health-record" dir="rtl">
      <Link to="/chat-health-record" className={HR.profileLink}>
        <span className={HR.profileText}>
          <span className={HR.profileTitle}>پرونده‌ی سلامت</span>
          <span className={HR.muted}>ویزیت‌ها، تصویرها، داروها و شاخص‌های شما و خانواده</span>
        </span>
        <ChevronIcon dir="left" className="h-3 w-3 text-slate-400" aria-hidden />
      </Link>
    </section>
  );
}
